import React from 'react'
import ListBrandsContext from "../context/ListBrandsContext";
import PropTypes from 'prop-types'

function ListBrandsProvider(props) {
    const {loadBrandsList, setState, filters, handleClickEditBrand} = props

    return (
        <ListBrandsContext.Provider
            value={{
                reLoadBrandsList: loadBrandsList,
                filters,
                setState: setState,
                handleClickEditBrand
            }}
        >
            {props.children}
        </ListBrandsContext.Provider>
    )
}

ListBrandsProvider.propTypes = {
    loadBrandsList: PropTypes.func.isRequired
}

export default ListBrandsProvider
